import createLucideIcon from '../createLucideIcon';

const ChevronDownSquare = createLucideIcon('ChevronDownSquare', [
  [
    'rect',
    {
      width: '18',
      height: '18',
      x: '3',
      y: '3',
      rx: '2',
      ry: '2',
      key: '1m3agn',
    },
  ],
  ['polyline', { points: '16,10 12,14 8,10', key: '1vamsg' }],
]);

export default ChevronDownSquare;
